import React from "react" 

import {Navbar2} from "./components/Navbar" 

import dataInfo from "./data.js"




export default function ProjRoboArm() 
{
    let projInfo = dataInfo[0];

    for (let i=0; i<dataInfo.length; i++)
    {
        if(dataInfo.at(i).id == 5)
        {
            projInfo = dataInfo.at(i);
            break;
        }
    }

    // console.log("projInfo: ", projInfo)

    const bullets = projInfo.bullets.split(";").map(bullet => bullet.trim());

    const BulletElement = bullets.map((bullet, index) => 
                        {
                            return( 
                            <li key={index} >  {bullet}  </li> 
                             );
                        } );

    return ( 
        <div>
            <Navbar2/>

            <div class="aboutContainer">

                <div class="aboutLeft">

                <iframe src="https://drive.google.com/file/d/1fIwEqpmg0QG3jg_z1WrMAmZyxgD5Ut9O/preview"
                  width="640" height="480" allow="autoplay"></iframe>
                  {/* width="640" height="480" */}

                </div>

                <div class="aboutRight">

                        <h1 >
                            {projInfo.title}
                        </h1>

                        <p>
                        {projInfo.description.split('\n').map((line, index) => (
                            <React.Fragment key={index}>
                                {line}
                                    <br />
                                </React.Fragment>
                            ))}

                            {/* {projInfo.description} */}
                        </p>

                        <ul>
                            {BulletElement}
                        </ul>

                        {
                            projInfo.downloadLink!="" ? 
                            <a className="skillTab" href={projInfo.downloadLink}  download={projInfo.downloadName} >
                            Download the application
                            </a> : null
                        }

                        {
                            projInfo.liveDemoLink!="" ? 
                            <a className="skillTab" href={projInfo.liveDemoLink}  target="_blank" >
                            Live Demo
                            </a> : null
                        }

                        {
                            projInfo.githubLink!="" ? 
                            <a className="skillTab" href={projInfo.githubLink}  target="_blank">
                            Github link
                            </a> : null
                        }
                        

                </div>
             </div>

        </div>
    )
}

